import script from "./LichessOpenView.vue?vue&type=script&setup=true&lang=js"
export * from "./LichessOpenView.vue?vue&type=script&setup=true&lang=js"

import "./LichessOpenView.vue?vue&type=style&index=0&id=8d2f5a40&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d2f5a40"]])

export default __exports__